/* Fortune Simple — behavior (uses a DOM "card pool" for images) */
(function(){
  const EVENTS = ['shopify:section:load','shopify:section:select','shopify:section:deselect','shopify:section:reorder'];
  const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeJSON = (t,f)=>{ try{ return JSON.parse(t); }catch(e){ return f; } };

  function readJSONScript(node){
    if(!node) return null;
    const txt = node.textContent || (node.innerText || '');
    return safeJSON(txt, null);
  }

  function initSection(sec){
    if (!sec || sec.__fortuneReady) return; sec.__fortuneReady = true;

    const pattNode = sec.querySelector('#pattern-' + sec.dataset.sectionId) || sec.querySelector('script[id^="pattern-"]');
    const patternStr = (pattNode ? readJSONScript(pattNode) : "") ||
                       "I see a {1} {2} from {3} in your future…";

    const cfgNode = sec.querySelector('#cfg-' + sec.dataset.sectionId) || sec.querySelector('script[id^="cfg-"]');
    const cfg = readJSONScript(cfgNode) || {blanks:[]};
    const blanks = Array.isArray(cfg.blanks) ? cfg.blanks : [];

    const para = sec.querySelector('.para');
    const res  = sec.querySelector('.result');
    const dateEl = sec.querySelector('.date');
    const cardBox = sec.querySelector('.card');
    const cardImg = sec.querySelector('.fortune-card');
    const headingEl = sec.querySelector('.result-heading');
    const grid = sec.querySelector('.products');

    // Build card pool from DOM
    const pool = Array.from(sec.querySelectorAll('.card-pool [data-src]'))
      .map(n => (n.getAttribute('data-src') || '').trim())
      .filter(Boolean);

    const limit = parseInt(sec.dataset.limit || '6', 10);
    const addEnabled = sec.dataset.enableAdd === 'true';
    const showPrice = sec.dataset.showPrice === 'true';
    const resultHeading = sec.dataset.resultHeading || "Here are your curated vintage picks based on today’s fortune.";
    const addLabel   = sec.dataset.addLabel   || 'Add to cart';
    const addedLabel = sec.dataset.addedLabel || 'Added!';
    const errorLabel = sec.dataset.errorLabel || 'Try again';
    const viewLabel  = sec.dataset.viewLabel  || 'View product';

    function gatherValuesAndHandles(){
      const vals=[]; const handles=[];
      para.querySelectorAll('.inline-blank').forEach(inp=>{
        const i=Number(inp.dataset.idx||0); vals[i]=(inp.value||'').trim();
        const b=(blanks||[])[i]||{}; if(b.kind!=='select' && b.collection_handle){ handles.push(b.collection_handle); }
      });
      para.querySelectorAll('.inline-select').forEach(sel=>{
        const i=Number(sel.dataset.idx||0); const opt=sel.options[sel.selectedIndex];
        vals[i]= (opt ? (opt.text||'') : '').trim();
        const h = opt ? (opt.dataset.handle||'') : ''; if (h) handles.push(h);
      });
      return { vals, handles };
    }

    async function fetchColl(handle){
      if(!handle) return [];
      try{
        const r = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=100`, {credentials:'same-origin'});
        if(!r.ok) return []; const d=await r.json(); return d.products||[];
      }catch(e){ return []; }
    }

    function renderProducts(list){
      grid.innerHTML='';
      if(!list.length){ grid.innerHTML='<div style="color:var(--muted);">No items found.</div>'; return; }

      list.slice(0, limit).forEach(p=>{
        const img = (p.images && p.images[0]) ? p.images[0].src : (p.image ? p.image.src : null);
        const first = (p.variants || []).find(v=>v.available) || (p.variants || [])[0];

        const card = document.createElement('div');
        card.className = 'p-card';
        card.innerHTML = `
          <a href="/products/${encodeURIComponent(p.handle)}" class="p-link">
            <div class="p-media">${img ? `<img class="p-img" src="${img}" alt="${esc(p.title)}">` : ``}</div>
            <div class="p-title">${esc(p.title)}</div>
          </a>
          ${ showPrice && p.variants && p.variants[0] ? `<div class="p-meta">${esc(p.variants[0].price)}</div>` : ``}
          <div class="p-actions">
            ${ addEnabled && first
                ? `<button class="btn" type="button" data-vid="${first.id}">${esc(addLabel)}</button>`
                : `<a class="btn" href="/products/${encodeURIComponent(p.handle)}">${esc(viewLabel)}</a>`}
          </div>
        `;
        grid.appendChild(card);
      });

      if (addEnabled){
        grid.querySelectorAll('button[data-vid]').forEach(b=>{
          b.addEventListener('click', async ()=>{
            const id = b.getAttribute('data-vid'); const orig = b.textContent; b.disabled = true;
            try{
              const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(id),quantity:1})});
              if(!r.ok) throw 0; b.textContent = addedLabel;
            }catch(e){ b.textContent = errorLabel; }
            finally{ setTimeout(()=>{ b.disabled=false; b.textContent=orig; }, 1500); }
          });
        });
      }
    }

    // Generate
    sec.querySelector('[data-action="gen"]')?.addEventListener('click', async (ev)=>{
      ev.preventDefault();
      const { handles } = gatherValuesAndHandles();

      // Date
      if (sec.dataset.showDate === 'true'){
        const d=new Date(); dateEl.textContent=d.toLocaleDateString(undefined,{year:'numeric',month:'long',day:'numeric'});
      } else { dateEl.textContent=''; }

      // Fortune card: pick from DOM pool, cache-bust, reveal on load
      cardBox.hidden = true;
      cardImg.removeAttribute('src');
      if (pool.length){
        const pickRaw = pool[Math.floor(Math.random()*pool.length)];
        const pick = pickRaw + (pickRaw.includes('?') ? '&' : '?') + 'v=' + Date.now();
        cardImg.onload  = ()=>{ cardBox.hidden = false; };
        cardImg.onerror = ()=>{ cardBox.hidden = true;  };
        cardImg.src = pick;
      }

      // Heading
      sec.querySelector('.result-heading').textContent = resultHeading;

      // Products
      const uniqueHandles = Array.from(new Set(handles.filter(Boolean)));
      const batches = await Promise.all(uniqueHandles.map(fetchColl));
      const all = []; batches.forEach(arr=>{ if(Array.isArray(arr)) all.push(...arr); });
      renderProducts(all);

      res.hidden = false;
      res.scrollIntoView({behavior:'smooth'});
    });

    // Clear
    sec.querySelector('[data-action="clear"]')?.addEventListener('click', (ev)=>{
      ev.preventDefault();
      para.querySelectorAll('.inline-blank').forEach(i=>i.value='');
      para.querySelectorAll('.inline-select').forEach(s=>s.selectedIndex=0);
      cardImg.removeAttribute('src'); cardBox.hidden = true;
      headingEl.textContent=''; grid.innerHTML=''; dateEl.textContent=''; res.hidden=true;
    });
  }

  function initAll(){ document.querySelectorAll('.fortune-sec').forEach(initSection); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  EVENTS.forEach(evt=>{ document.addEventListener(evt, e=>{ (e.target||document).querySelectorAll?.('.fortune-sec').forEach(sec=>{ sec.__fortuneReady=false; initSection(sec); }); }); });
})();
